/* ==========================================================================
   KAVANOZU DOLDUR — oyun mantığı
   Bağımsız çalışır: sayfanın geri kalanına (tema, header, diğer scriptler)
   hiçbir bağımlılığı yoktur. Ayarlar window.CEREZSHOP_OYUN_CONFIG üzerinden
   section'dan gelir (bkz. sections/cerezshop-oyun.liquid).
   ========================================================================== */
(function () {
  'use strict';

  var cfg = window.CEREZSHOP_OYUN_CONFIG || {};
  // SÜRE BAZLI OYUN: sabit bir "toplam ürün sayısı kadar bekle" yerine
  // artık oyun sabit bir süre (OYUN_SURESI_SN) boyunca sürüyor. Süre
  // dolunca (ya da TOPLAM_DUSEN'in tamamı spawn olup ekran boşalınca,
  // hangisi önce gelirse) oyun biter; kademe kaç ürün yakalandığına
  // göre hesaplanır.
  var OYUN_SURESI_SN = Math.max(5, parseInt(cfg.oyunSuresiSn, 10) || 25);
  var TOPLAM_DUSEN = Math.max(5, parseInt(cfg.toplamUrun, 10) || 30);
  // Kademeli ödül sistemi: 4 kazanma kademesi (indirim5 -> indirim10 ->
  // jumbo -> cikolatin) + başarısız. Çikolatin artık EN BÜYÜK/son
  // kademe — ayrı bir üst eşiği yok, jumbo eşiğinin üstündeki her şey
  // çikolatin sayılır. (Eskiden "hediye" adında ayrı bir kademe vardı,
  // kaldırıldı; jumbo onun yerine geçti, çikolatin en zor/en büyük ödül
  // olarak eklendi.)
  var ESIK_BASARISIZ = parseInt(cfg.esikBasarisiz, 10);
  var ESIK_INDIRIM5 = parseInt(cfg.esikIndirim5, 10);
  var ESIK_INDIRIM10 = parseInt(cfg.esikIndirim10, 10);
  var ESIK_JUMBO = parseInt(cfg.esikJumbo, 10);
  if (isNaN(ESIK_BASARISIZ)) ESIK_BASARISIZ = 9;
  if (isNaN(ESIK_INDIRIM5)) ESIK_INDIRIM5 = 15;
  if (isNaN(ESIK_INDIRIM10)) ESIK_INDIRIM10 = 25;
  if (isNaN(ESIK_JUMBO)) ESIK_JUMBO = 28;
  // Eşikler admin panelden yanlışlıkla ters/çakışık girilirse oyun
  // mantığının bozulmaması için sıralı ve TOPLAM_DUSEN'in altında
  // kalmaları garanti ediliyor. Çikolatin (en üst kademe) ESIK_JUMBO'dan
  // TOPLAM_DUSEN'e kadar olan aralıktır, ayrı bir eşiği yok.
  ESIK_INDIRIM5 = Math.max(ESIK_INDIRIM5, ESIK_BASARISIZ + 1);
  ESIK_INDIRIM10 = Math.max(ESIK_INDIRIM10, ESIK_INDIRIM5 + 1);
  ESIK_JUMBO = Math.min(Math.max(ESIK_JUMBO, ESIK_INDIRIM10 + 1), TOPLAM_DUSEN - 1);
  var ADI_INDIRIM5 = cfg.adIndirim5 || '%5 İndirim';
  var ADI_INDIRIM10 = cfg.adIndirim10 || '%10 İndirim';
  var ADI_JUMBO = cfg.adJumbo || 'Jumbo Hediye';
  var ADI_CIKOLATIN = cfg.adCikolatin || 'Çikolatin';
  var URUNLER = Array.isArray(cfg.urunler) && cfg.urunler.length ? cfg.urunler : [];
  // Spawn aralığı artık SABİT değil — oyunun başında yavaş (SPAWN_BASLANGIC),
  // süre azaldıkça hızlanıp sona doğru SPAWN_BITIS'e kadar daralıyor
  // ("saniye azaldıkça düşme sayısı artsın" isteği).
  // "oyun en başta yavaş başlıyor, genel olarak biraz daha hızlandır"
  // isteğiyle hem spawn aralığı hem düşme hızı tüm kademelerde bir kez
  // daha yükseltildi.
  var SPAWN_ARALIK_BASLANGIC = 650;
  var SPAWN_ARALIK_BITIS = 360;
  var DUSME_HIZ_MIN = 108;
  var DUSME_HIZ_MAX = 148;
  var HIZ_ZAMAN_ARTISI = 0.85;
  var MIN_SPAWN_MESAFESI_ORANI = 0.24; // aynı anda düşen ürünler bu kadar yakın olamaz (sahne genişliğine oran)
  // Sabit piksel — web'de sahne 560-640px'e çıkınca yüzde tabanlı boyut
  // orantılı büyüyüp "ürünler büyük duruyor" şikayetine yol açmıştı.
  // .ok-dusen-oge CSS genişliğiyle (width: 42px) eşleşmeli.
  // Mobilde sabit kalması ("50 çok çok az fazlaydı" diye 46'ya
  // düşürülmüştü), ama web'de sahne 560-640px'e çıkınca 46px görece
  // ufak kalıyordu ("ürünler webde ufak kalmış"). Artık ekran
  // genişliğine göre (CSS'teki 700px/1000px kırılımlarıyla eşleşecek
  // şekilde) ayrı bir değer kullanılıyor — mobil dokunulmadı, sadece
  // web için büyütüldü.
  function genislikPxHesapla() {
    if (window.innerWidth >= 1000) return 66;
    if (window.innerWidth >= 700) return 56;
    return 46;
  }
  var GENISLIK_PX = genislikPxHesapla();

  var sahne = document.querySelector('[data-ok-sahne]');
  if (!sahne || !URUNLER.length) return;

  var dusenKatman = sahne.querySelector('[data-ok-dusen-katman]');
  var kavanoz = sahne.querySelector('[data-ok-kavanoz]');
  var yigin = sahne.querySelector('[data-ok-yigin]');
  var ilerlemeBar = document.querySelector('[data-ok-ilerleme-bar]');
  var ilerlemeMesajEl = document.querySelector('[data-ok-ilerleme-mesaj]');
  var sureEl = document.querySelector('[data-ok-sure]');
  var elIpucuEl = sahne.querySelector('[data-ok-el-ipucu]');
  var solBtn = document.querySelector('[data-ok-sol]');
  var sagBtn = document.querySelector('[data-ok-sag]');
  var baslatPerde = sahne.querySelector('[data-ok-baslat-perde]');
  var baslatBtn = sahne.querySelector('[data-ok-baslat-btn]');
  var baslatSayacEl = sahne.querySelector('[data-ok-baslat-sayac]');
  var geriSayimEl = sahne.querySelector('[data-ok-geri-sayim]');
  var sonucKatman = sahne.querySelector('[data-ok-sonuc]');
  // 5 sonuç kartının her birinin kendi kupon/kopyala/tekrar elemanları
  // var (aynı anda sadece biri görünür ama hepsine event bağlanmalı).
  var kopyalaBtnlar = document.querySelectorAll('[data-ok-kopyala]');
  var tekrarBtnlar = document.querySelectorAll('[data-ok-tekrar]');
  var devamBtnlar = document.querySelectorAll('[data-ok-devam-btn]');
  var konfetiKatman = sahne.querySelector('[data-ok-konfeti]');

  var azaltilmisHareket = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var sahneGenislik = 0, sahneYukseklik = 0;
  var kavanozGenislik = 0, kavanozYukseklik = 0, kavanozTopPxOnbellek = 0;
  var kavanozX = 0; // sol kenar
  var HIZ_PX_SN = 260; // buton ile hareket hızı

  var aktifDusenler = [];
  var yakalanan = 0;
  var dusenSayisi = 0; // şimdiye kadar spawn edilen toplam ürün (TOPLAM_DUSEN sınırı için)
  var oyunAktif = false;
  var oyunBitecekMi = false;
  var oyunSonucu = null; // 'basarisiz' | 'indirim5' | 'indirim10' | 'jumbo' | 'cikolatin'
  var oyunBaslangicZamani = null; // rAF zaman damgası cinsinden — süre bazlı oyun için
  var spawnTimer = null;
  var sonRaf = null;
  var solBasili = false, sagBasili = false;
  var suruklemeBaslangicX = null, suruklemeKavanozBaslangicX = 0;

  // .ok-sahne'nin 3px'lik border'ı var; içindeki mutlak konumlanan çocuklar
  // (kavanoz, düşen ürünler) sahnenin PADDING KUTUSUNA göre yerleşiyor
  // (border hariç), ama eskiden sahneGenislik/Yükseklik
  // getBoundingClientRect ile BORDER dahil ölçülüyordu. Bu yüzden
  // kavanozun "maksimum X" hesabı gerçekte olduğundan ~6px fazla
  // genişlik varsayıyor, kavanoz sağa gittiğinde iç kenara hiç
  // değmeden (görünürde birkaç piksel boşluk bırakarak) duruyordu —
  // "kavanoz tam köşeye gidemiyor" şikayetinin sebebi buydu.
  var SAHNE_BORDER_PX = 3;

  function olcek() {
    sahneGenislik = sahne.clientWidth; // clientWidth = border HARİÇ (padding kutusu)
    sahneYukseklik = sahne.clientHeight;
    kavanozGenislik = kavanoz.offsetWidth;
    kavanozYukseklik = kavanoz.offsetHeight;
    var r = sahne.getBoundingClientRect();
    var kRect = kavanoz.getBoundingClientRect();
    kavanozTopPxOnbellek = (kRect.top - r.top) - SAHNE_BORDER_PX;
    kavanozXAyarla(kavanozX); // sınırları yeniden uygula
  }

  function kavanozXAyarla(x) {
    var maxX = Math.max(0, sahneGenislik - kavanozGenislik);
    kavanozX = Math.min(Math.max(0, x), maxX);
    kavanoz.style.transform = 'translateX(' + kavanozX + 'px)';
  }

  function rastgele(min, max) { return Math.random() * (max - min) + min; }
  // Ürünler artık rastgele değil, listede SIRAYLA (baştan sona, sonra
  // başa dönerek) düşüyor — hangi ürünün ne zaman geleceği daha
  // öngörülebilir/dengeli oluyor (aynı ürün art arda çok az geliyor).
  var urunSirasi = 0;
  function siradakiUrun() {
    var urun = URUNLER[urunSirasi % URUNLER.length];
    urunSirasi++;
    return urun;
  }

  // Oyun başlangıcından bu yana geçen sürenin OYUN_SURESI_SN'e oranı
  // (0 = daha yeni başladı, 1 = süre bitti). Hem düşme hızını hem spawn
  // sıklığını buna göre kademeli olarak artırıyoruz.
  function zamanOrani() {
    if (oyunBaslangicZamani === null) return 0;
    var gecen = (performance.now() - oyunBaslangicZamani) / 1000;
    return Math.min(1, Math.max(0, gecen / OYUN_SURESI_SN));
  }

  function uygunSolPxBul(genislikPx) {
    var maxSolPx = sahneGenislik - genislikPx;
    var minMesafe = sahneGenislik * MIN_SPAWN_MESAFESI_ORANI;

    // Ekranın üst yarısında hâlâ "yeni sayılan" düşenlerle çakışmayı önle;
    // alttakiler zaten uzaklaşmış olur, onlarla mesafe aramaya gerek yok.
    var yakinlar = aktifDusenler.filter(function (d) {
      return d.y < sahneYukseklik * 0.45;
    });

    for (var deneme = 0; deneme < 8; deneme++) {
      var aday = rastgele(4, Math.max(4, maxSolPx - 4));
      var carpisiyor = yakinlar.some(function (d) {
        return Math.abs(d.solPx - aday) < minMesafe;
      });
      if (!carpisiyor) return aday;
    }
    return rastgele(4, Math.max(4, maxSolPx - 4)); // 8 denemede olmazsa rastgele bırak, oyunu tıkamasın
  }

  function dusenOlustur() {
    if (!oyunAktif) return;
    dusenSayisi++;
    var urun = siradakiUrun();
    var el = document.createElement('div');
    el.className = 'ok-dusen-oge';
    var img = document.createElement('img');
    img.src = urun.gorsel;
    img.alt = '';
    img.setAttribute('aria-hidden', 'true');
    img.loading = 'eager';

    // Her ürün kendi ekseninde rastgele yönde ve rastgele hızda döner;
    // hepsi aynı anda aynı fazda dönmesin diye süre ve yön ayrı ayrı seçiliyor.
    var donmeSuresi = rastgele(2.8, 4.6).toFixed(2);
    var donmeYonu = Math.random() < 0.5 ? 1 : -1;
    img.style.animation = 'ok-urun-don ' + donmeSuresi + 's linear infinite';
    img.style.setProperty('--ok-donme-yonu', donmeYonu);

    el.appendChild(img);

    var solPx = uygunSolPxBul(GENISLIK_PX);
    el.style.left = solPx + 'px';

    dusenKatman.appendChild(el);

    // Kalan süre azaldıkça hız artıyor (yakalanan sayısıyla değil) —
    // spawn anındaki zaman oranı sabitleniyor, bu ürün düşerken hız
    // birden değişmiyor ama SONRAKİ ürünler süre ilerledikçe daha hızlı
    // spawn oluyor.
    var hizCarpani = 1 + zamanOrani() * HIZ_ZAMAN_ARTISI;

    aktifDusenler.push({
      el: el,
      y: -70,
      hiz: rastgele(DUSME_HIZ_MIN, DUSME_HIZ_MAX) * hizCarpani,
      solPx: solPx,
      genislikPx: GENISLIK_PX,
      urun: urun,
      yakalandi: false,
      kayip: false,
      sekmeVX: 0,
      sekmeX: 0
    });
  }

  function spawnDongusuBaslat() {
    (function dongu() {
      if (!oyunAktif) return;
      // TOPLAM_DUSEN'e ulaşıldıysa artık yeni ürün spawn edilmiyor; oyun,
      // süre dolunca ya da ekran boşalınca oyunFrame içindeki kontrolle
      // sona erer.
      if (dusenSayisi >= TOPLAM_DUSEN) return;
      dusenOlustur();
      // Spawn aralığı süre ilerledikçe daralıyor ("saniye azaldıkça
      // düşme sayısı artsın" isteği) — oyunun sonuna doğru çok daha sık
      // ürün düşüyor.
      var f = zamanOrani();
      var aralik = SPAWN_ARALIK_BASLANGIC + (SPAWN_ARALIK_BITIS - SPAWN_ARALIK_BASLANGIC) * f;
      spawnTimer = window.setTimeout(dongu, aralik);
    })();
  }

  var sonZaman = null;
  function oyunFrame(zaman) {
    if (!oyunAktif) return;
    if (sonZaman === null) sonZaman = zaman;
    var dt = Math.min(48, zaman - sonZaman) / 1000;
    sonZaman = zaman;

    // Buton ile sürekli hareket
    if (solBasili) kavanozXAyarla(kavanozX - HIZ_PX_SN * dt);
    if (sagBasili) kavanozXAyarla(kavanozX + HIZ_PX_SN * dt);

    // Geri sayım: her karede güncellenir, 10 saniyenin altında kırmızı
    // yanıp söner (bkz. CSS .ok-sure.kritik).
    var kalanSn = OYUN_SURESI_SN;
    if (oyunBaslangicZamani !== null) {
      kalanSn = Math.max(0, OYUN_SURESI_SN - (performance.now() - oyunBaslangicZamani) / 1000);
    }
    if (sureEl) {
      sureEl.textContent = Math.ceil(kalanSn);
      sureEl.classList.toggle('kritik', kalanSn <= 10 && kalanSn > 0);
    }

    // Yakalama: ürün görsel olarak kavanozun ağzının biraz İÇİNE girmeden
    // yakalanmış sayılmaz — "tam içine girmeden kayboluyor" hissi buradan
    // geliyordu. Üst kenar (d.y) artık kavanozun tepesinden değil, ağzın
    // birazcık içinden itibaren kontrol ediliyor.
    var kavanozTopPx = kavanozTop();
    var girisEsigi = kavanozTopPx + kavanozYukseklik * 0.14;
    var yakalaYAlt = kavanozTopPx + kavanozYukseklik * 0.5;
    // Yakalama bandının kenar payı SABİT değil — huni şeklinde daralıyor.
    // Gerçek kavanoz fotoğrafının ağzı, dikdörtgen kutunun köşelerine
    // kadar dolu değil (yuvarlak/oval bir ağız) — ağzın hemen girişinde
    // (girisEsigi'ne yakın) kenar payı geniş (%20) tutulup üst
    // KÖŞELERDE yanlışlıkla yakalama yapılması engelleniyor; ürün
    // ağzın biraz daha içine/aşağısına indikçe (yakalaYAlt'a yaklaştıkça)
    // pay daralıyor (%8'e kadar) — böylece önceki "en köşedeki ürünleri
    // yakalayamıyor" düzeltmesi de (kavanoz gövde hizasında/köşedeyken
    // hâlâ yakalayabilmesi) korunuyor. KENAR_PAYI_UST/ALT fonksiyonu
    // aşağıda her ürün için d.y'ye göre ayrı ayrı hesaplanıyor.
    var KENAR_PAYI_UST = 0.20;
    var KENAR_PAYI_ALT = 0.08;
    // Çarpma (sekme) için biraz daha geniş bir "yakın çevre" bandı.
    var yakinXSol = kavanozX - kavanozGenislik * 0.15;
    var yakinXSag = kavanozX + kavanozGenislik * 1.15;
    // Kayıp (kesin ıskalanmış) ürünlerin hâlâ kavanoza çarpıp sekebileceği
    // alt sınır — bu noktadan sonra artık kavanozdan iyice uzaklaşmış
    // sayılır, hiçbir etkileşim kontrolü çalışmaz.
    //
    // KÖK NEDEN DÜZELTMESİ: bu pencere eskiden sadece kavanozYukseklik*0.3
    // kadardı (mobilde ~110px yükseklikte bir kavanoz için ~33px). Düşme
    // hızı artık süre ilerledikçe yükseldiği için (bkz.
    // HIZ_ZAMAN_ARTISI) üst seviyelerde ürün bu dar pencereyi 0.2 saniyeden
    // kısa sürede geçiyordu — sürtünme sönümü (aşağıda) sekmeVX'i sıfıra
    // indirmeye ~0.4-0.5 saniye ihtiyaç duyduğu için ikinci bir sekme
    // ASLA gerçekleşmiyordu ("2 kez sekmede çalışmıyor", "yukarı
    // pikselerde sekme olmuyor" şikayetleri buradan geliyordu — ürün
    // sekmiş SAYILIYORDU ama sönüm bitmeden pencere kapanıp etkileşim
    // tamamen kesiliyor, düz çizgide düşüp gidiyordu). Pencere 4 katına
    // çıkarıldı.
    var carpmaYAlt = yakalaYAlt + kavanozYukseklik * 1.3;

    for (var i = aktifDusenler.length - 1; i >= 0; i--) {
      var d = aktifDusenler[i];
      d.y += d.hiz * dt;

      // Sekme fiziği: varsa yatay hız uygulanır ve sürtünmeyle sönümlenir.
      // dt'ye bağlı üstel sönüm kullanmak, frame hızından bağımsız aynı
      // "yavaşlama hissini" verir (düşük/yüksek fps'te de tutarlı).
      if (d.sekmeVX) {
        d.sekmeX += d.sekmeVX * dt;
        // Üst (0.0002) eskiden 0.006'ydı — artan düşme hızlarıyla sönüm
        // süresi (~0.4-0.5sn) genişletilmiş pencereyi bile aşabiliyordu.
        // Şimdi ~0.2-0.25sn'de sıfırlanıyor, her hızda güvenilir şekilde
        // tekrar sekilebilir hale geliyor.
        d.sekmeVX *= Math.pow(0.0002, dt);
        if (Math.abs(d.sekmeVX) < 3) d.sekmeVX = 0;
      }

      d.el.style.transform = 'translate(' + (d.sekmeX || 0) + 'px, ' + d.y + 'px)';

      var ogeMerkezX = d.solPx + (d.sekmeX || 0) + d.genislikPx / 2;

      // Huni: girisEsigi'nde (t=0) kenar payı %20, yakalaYAlt'ta (t=1)
      // %8. Ürün pencerenin neresindeyse (d.y) ona göre aradeğer alınır.
      var t = (d.y - girisEsigi) / (yakalaYAlt - girisEsigi);
      t = Math.min(1, Math.max(0, t));
      var kenarPayi = KENAR_PAYI_UST + (KENAR_PAYI_ALT - KENAR_PAYI_UST) * t;
      var yakalaXSol = kavanozX + kavanozGenislik * kenarPayi;
      var yakalaXSag = kavanozX + kavanozGenislik * (1 - kenarPayi);

      if (!d.yakalandi && !d.kayip) {
        if (d.y >= girisEsigi && d.y <= yakalaYAlt &&
            ogeMerkezX >= yakalaXSol && ogeMerkezX <= yakalaXSag) {
          d.yakalandi = true;
          yakala(d);
          continue;
        }
        // Yakalama penceresi tamamen kapandı ve yakalanmadıysa artık KESİN
        // ıskalanmış demektir — kavanoza bir daha asla giremez. Kullanıcı
        // kavanozu bu üründen sonra altına getirse bile bu bir "yakalama"
        // sayılmaz; sadece kenara çarpıp sekmesine (aşağıda) izin verilir.
        if (d.y > yakalaYAlt) d.kayip = true;
      }

      if (d.kayip && d.y <= carpmaYAlt && d.sekmeVX === 0 &&
          ogeMerkezX >= yakinXSol && ogeMerkezX <= yakinXSag) {
        // Kavanozun kenarına yakın geçiyor — sekiyor. sekmeVX sıfıra
        // dönüp ürün hâlâ bu bantta ve hâlâ kavanoza yakınsa (kullanıcı
        // kavanozu peşinden sürüklüyorsa) tekrar tekrar tetiklenir; her
        // defasında kavanozdan uzağa itilir ama ASLA yakalanmaz.
        sekmeUygula(d);
      }

      if (d.y > sahneYukseklik + 20) {
        d.el.remove();
        aktifDusenler.splice(i, 1);
      }
    }

    // Oyun sonu — iki koşuldan biri gerçekleşince: (1) süre doldu, ya da
    // (2) TOPLAM_DUSEN'in tamamı spawn edildi ve ekranda hâlâ düşmekte/
    // sekmekte olan hiçbir ürün kalmadı. Süre dolduğunda ekranda hâlâ
    // düşmekte olan ürünler varsa bile oyun hemen biter (net bir "süre
    // bitti" hissi için) — kaç tane yakalandıysa o kesinleşmiştir.
    if (!oyunBitecekMi && kalanSn <= 0) {
      oyunSonucu = sonucKademesi();
      oyunBitecekMi = true;
    }
    if (!oyunBitecekMi && dusenSayisi >= TOPLAM_DUSEN && aktifDusenler.length === 0) {
      oyunSonucu = sonucKademesi();
      oyunBitecekMi = true;
    }

    // Bitirme, for döngüsü tamamen bittikten SONRA tetiklenir. Döngü içinde
    // çağrılırsa aktifDusenler dizisi sıfırlanır ama döngü hâlâ eski uzunluğa
    // göre ilerlediği için "undefined okuma" hatası oluşuyordu.
    if (oyunBitecekMi) {
      oyunBitecekMi = false;
      oyunuBitir();
      return;
    }

    sonRaf = window.requestAnimationFrame(oyunFrame);
  }

  // Toplam yakalanan sayıya göre 5 kademeden hangisinin kazanıldığını
  // belirler. Eşikler "dahil" (ör. ESIK_BASARISIZ=4 ise 0-4 arası
  // başarısız, 5'ten itibaren indirim kademesi başlar).
  function sonucKademesi() {
    if (yakalanan <= ESIK_BASARISIZ) return 'basarisiz';
    if (yakalanan <= ESIK_INDIRIM5) return 'indirim5';
    if (yakalanan <= ESIK_INDIRIM10) return 'indirim10';
    if (yakalanan <= ESIK_JUMBO) return 'jumbo';
    return 'cikolatin';
  }

  // Oyun içinde sahnenin üstünde gösterilen "sıradaki ödüle X ürün
  // kaldı" mesajı. Yüzde yerine bunu göstermek, kullanıcının ekranda
  // net bir hedefi olmasını sağlıyor ("şu kadar ürün daha yakala, şu
  // ödülü kap" hissi).
  // Mesaj hem "şu an elinde olan ödülü" hem "bir sonraki, daha büyük
  // ödülü" gösterir — kullanıcı hem kazandığını görsün hem de bir
  // sonrakine yükselmek için motive olsun diye (ör. "Güncel ödülün:
  // %10 İndirim! 3 ürün daha yakala, Jumbo SN4CK Paketi kazan!").
  function ilerlemeMesajiHesapla(sayim) {
    var guncelAd = null;
    if (sayim > ESIK_BASARISIZ) guncelAd = ADI_INDIRIM5;
    if (sayim > ESIK_INDIRIM5) guncelAd = ADI_INDIRIM10;
    if (sayim > ESIK_INDIRIM10) guncelAd = ADI_JUMBO;
    if (sayim > ESIK_JUMBO) guncelAd = ADI_CIKOLATIN;

    // Çikolatin artık EN BÜYÜK/son kademe — üstünde başka bir hedef yok.
    if (sayim > ESIK_JUMBO) {
      return 'Güncel ödülün: ' + ADI_CIKOLATIN + '! 👑 En büyük ödülü kaptın!';
    }

    var siradakiAd, esikSira;
    if (sayim <= ESIK_BASARISIZ) {
      siradakiAd = ADI_INDIRIM5; esikSira = ESIK_BASARISIZ;
    } else if (sayim <= ESIK_INDIRIM5) {
      siradakiAd = ADI_INDIRIM10; esikSira = ESIK_INDIRIM5;
    } else if (sayim <= ESIK_INDIRIM10) {
      siradakiAd = ADI_JUMBO; esikSira = ESIK_INDIRIM10;
    } else {
      siradakiAd = ADI_CIKOLATIN; esikSira = ESIK_JUMBO;
    }

    var kalan = esikSira + 1 - sayim;
    var urunKelimesi = kalan === 1 ? 'ürün' : 'ürün daha';
    var siradakiCumle = kalan + ' ' + urunKelimesi + ' yakala, ' + siradakiAd + ' kazan!';

    if (guncelAd) {
      return 'Güncel ödülün: ' + guncelAd + '! ' + siradakiCumle;
    }
    return siradakiCumle;
  }

  function kavanozTop() {
    // Kavanoz yalnızca yatayda hareket eder; dikey konumu olcek() içinde önbelleklenir.
    return kavanozTopPxOnbellek;
  }

  function sekmeUygula(d) {
    if (azaltilmisHareket) return;
    // Kavanozdan uzağa doğru bir "itilme" hızı verilir; oyunFrame içinde
    // her karede sürtünmeyle sönümlenir. CSS keyframe yerine bunu tercih
    // etmemin sebebi: JS zaten transform'u her frame yeniden yazıyordu,
    // eş zamanlı bir CSS animasyonu bu yazımla çakışıp anında eziliyordu.
    var kavanozMerkezX = kavanozX + kavanozGenislik / 2;
    var ogeMerkezX = d.solPx + d.genislikPx / 2;
    var yon = ogeMerkezX < kavanozMerkezX ? -1 : 1;
    d.sekmeVX = yon * rastgele(110, 170); // px/sn
    d.sekmeX = 0;
  }

  function yakala(d) {
    d.el.remove();
    var idx = aktifDusenler.indexOf(d);
    if (idx > -1) aktifDusenler.splice(idx, 1);

    if (!azaltilmisHareket) {
      var img = kavanoz.querySelector('.ok-kavanoz-img');
      if (img) {
        img.classList.remove('titriyor');
        void img.offsetWidth; // yeniden tetiklenebilmesi için reflow zorla
        img.classList.add('titriyor');
        window.setTimeout(function () { img.classList.remove('titriyor'); }, 300);
      }
    }

    yakalanan++;
    guncelleIlerleme();

    var mini = document.createElement('div');
    mini.className = 'ok-yigin-oge';
    var urunImg = document.createElement('img');
    urunImg.src = d.urun.gorsel;
    urunImg.alt = '';
    // Dönüş (rastgele hafif eğim) img'e uygulanıyor, mini'ye değil —
    // mini'nin transform'u zaten "ok-yigin-gir" animasyonu tarafından
    // (opacity/scale için) kullanılıyor; ikisi aynı elemanda çakışırsa
    // animasyon bitince rotate sıfırlanıp ürün dümdüz kalıyordu.
    urunImg.style.transform = 'rotate(' + rastgele(-14, 14).toFixed(1) + 'deg)';
    mini.appendChild(urunImg);

    // --- Yığın yerleşimi: SATIR SATIR ---
    // .ok-yigin, kavanoz görselinin ARKASINDA durur (bkz. CSS —
    // .ok-kavanoz-img z-index'i daha yüksek), yani kavanozun opak
    // gövdesiyle çakışan ürün otomatik GİZLİ kalır; üst sınır negatife
    // düşünce (kavanozun tepe çizgisinin ÜSTÜNE) görünür hâle gelir.
    //
    // Eskiden her yakalanan ürün, sadece kendi sırasına göre biraz daha
    // yukarıya, dar-ve-merkezi bir bantta rastgele konuluyordu — sonuç
    // ince, ortada, gerçekçi olmayan bir şeritti (kavanozun sağında/
    // solunda boşluk kalıyordu). Artık ürünler KAT KAT diziliyor:
    //   • Her SATIR_URUN_SAYISI ürün bir kat.
    //   • Alt katlar kavanozun AĞZINI enine DOLDURUR (geniş bant).
    //   • Yukarı çıkan taşma katları ORTAYA toplanıp sivrilir (mound).
    //   • Her kat merkeze göre simetrik → taşma sadece YUKARI, yanlara
    //     kayma yok.
    var SATIR_URUN_SAYISI = 3;
    var satir = Math.floor((yakalanan - 1) / SATIR_URUN_SAYISI);
    var satirIci = (yakalanan - 1) % SATIR_URUN_SAYISI; // 0,1,2
    // Dikey: 0. kat kavanoz gövdesinin üst kısmında (gizli). Kat yükseldikçe
    // dikey adım KISALIYOR (10 -> ~5) — gerçek bir yığın gibi yukarı
    // çıktıkça daha çok ENİNE yayılıp boyuna yavaşlıyor; böylece üst
    // katlar "kule" gibi dikleşmiyor, dome/tepe oluşuyor. Kapalı biçimli
    // birikim: her katın adımı bir öncekinden 0.6 az.
    //   satirTop(n) = 27 - Σ_{k=0..n-1}(10 - 0.6k)
    //              = 27 - (10n - 0.3n(n-1))
    var satirTop = 27 - (10 * satir - 0.3 * satir * (satir - 1)) + rastgele(-2, 2);
    // ~3. kattan (10-12. ürün) itibaren üst sınır negatife düşüp ağzın
    // üstüne taşıyor (istenen: taşma ~10-11. üründe başlasın).
    // Yatay: kavanoz görselinin GERÇEK yatay ortası %51.5, ağzı ~%20-83
    // arası (asset piksel taramasından). Alt katlar tam geniş bant (ağzı
    // boydan boya doldurur); üst katlarda bant daralıyor AMA iğne ucu
    // olmasın diye %11'de (yani ~%48 toplam en) tabanlanıyor — dome.
    var AGIZ_MERKEZ = 51.5;
    var yarimBant = Math.max(11, 21 - Math.max(0, satir - 2) * 2.3);
    var slot = satirIci - 1; // -1, 0, +1
    var merkezX = AGIZ_MERKEZ + slot * yarimBant + rastgele(-3, 3);
    // Hiçbir ürün kavanozun gerçek silüetinin (gövde ~%17-86) dışına
    // taşmasın — jitter uçlarda kenardan azıcık sızıp "kavanozun yanına
    // düşmüş" gibi görünmesini engelle. 13 = .ok-yigin-oge genişliğinin
    // (26%) yarısı.
    merkezX = Math.max(30, Math.min(71, merkezX));
    mini.style.left = (merkezX - 13) + '%';
    mini.style.top = satirTop + '%';
    // Z-index'te yeni gelen ARKADA durur — yığının ÖN yüzü eski/alçak
    // ürünler, arkası yeni/yüksek ürünler (önden bakılan gerçek bir
    // tepe hissi).
    mini.style.zIndex = 50 - yakalanan;

    yigin.appendChild(mini);
  }

  function guncelleIlerleme() {
    var yuzde = Math.round((yakalanan / TOPLAM_DUSEN) * 100);
    if (ilerlemeBar) ilerlemeBar.style.width = Math.min(100, yuzde) + '%';
    if (ilerlemeMesajEl) ilerlemeMesajEl.textContent = ilerlemeMesajiHesapla(yakalanan);
  }

  function oyunuBaslat() {
    if (oyunAktif) return;
    oyunAktif = true;
    oyunBitecekMi = false;
    oyunSonucu = null;
    yakalanan = 0;
    dusenSayisi = 0;
    urunSirasi = 0;
    guncelleIlerleme();
    if (baslatPerde) baslatPerde.style.display = 'none';
    olcek();
    kavanozXAyarla((sahneGenislik - kavanozGenislik) / 2);
    kavanoz.classList.remove('dolu');
    yigin.innerHTML = '';
    aktifDusenler.forEach(function (d) { d.el.remove(); });
    aktifDusenler = [];
    sonZaman = null;
    if (sureEl) {
      sureEl.textContent = OYUN_SURESI_SN;
      sureEl.classList.remove('kritik');
    }
    // Mobilde kavanozu sürüklerken sayfanın yukarı/aşağı kayması
    // şikayeti: sahne varsayılan olarak touch-action:pan-y (oyun
    // başlamadan/bittikten sonra sayfa kaydırılabilsin diye), ama oyun
    // aktifken bu sınıf touch-action'ı none'a çekip sahneyi sayfa
    // kaydırmasından tamamen izole ediyor (bkz. CSS .oyun-aktif).
    sahne.classList.add('oyun-aktif');
    // Perde kapanır kapanmaz süre işlemeye/ürün düşmeye başlamak yerine,
    // kullanıcı hazırlansın diye önce 3-2-1 geri sayımı gösteriliyor —
    // gerçek başlangıç (süre, spawn, animasyon döngüsü) geri sayım
    // bitince oyunGercektenBaslat() ile tetikleniyor.
    geriSayimBaslat();
  }

  var OYUN_GERI_SAYIM_SN = 3;
  function geriSayimBaslat() {
    if (!geriSayimEl) { oyunGercektenBaslat(); return; }
    var kalan = OYUN_GERI_SAYIM_SN;
    geriSayimEl.style.display = 'flex';
    geriSayimEl.textContent = kalan;
    var geriSayimTimer = window.setInterval(function () {
      kalan--;
      if (kalan <= 0) {
        window.clearInterval(geriSayimTimer);
        geriSayimEl.textContent = 'BAŞLA!';
        window.setTimeout(function () {
          geriSayimEl.style.display = 'none';
          oyunGercektenBaslat();
        }, 350);
        return;
      }
      geriSayimEl.textContent = kalan;
    }, 1000);
  }

  function oyunGercektenBaslat() {
    oyunBaslangicZamani = performance.now();
    elIpucuGoster();
    spawnDongusuBaslat();
    sonRaf = window.requestAnimationFrame(oyunFrame);
  }

  // Sonuç kartındaki "Alışverişe Başla/Devam Et" linki (data-ok-devam-btn),
  // giriş ekranındaki "Oyuna Başla" butonu gibi, kullanıcı kupon
  // kodunu/notu okusun diye DEVAM_BEKLEME_SN saniye kilitli kalıyor —
  // yanındaki sayaç geri sayıp süre bitince kilit kalkıyor. <a>
  // elementi native "disabled" desteklemediği için kilit hem görsel
  // (.ok-kilitli sınıfı) hem de tıklama engelleme (aşağıdaki click
  // listener'ı) ile uygulanıyor. Sadece "Hediyeni Sepete Ekle" JS
  // butonunda YOK — o zaten kendi "Ekleniyor…" akışına sahip.
  var DEVAM_BEKLEME_SN = 4;
  devamBtnlar.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      if (btn.classList.contains('ok-kilitli')) e.preventDefault();
    });
  });

  function devamButonuKilitle(kartEl) {
    if (!kartEl) return;
    var devamBtn = kartEl.querySelector('[data-ok-devam-btn]');
    if (!devamBtn) return;
    var sayacEl = kartEl.querySelector('[data-ok-devam-sayac]');
    if (devamBtn._okSayacTimer) window.clearInterval(devamBtn._okSayacTimer);
    devamBtn.classList.add('ok-kilitli');
    var kalan = DEVAM_BEKLEME_SN;
    if (sayacEl) sayacEl.textContent = kalan;
    devamBtn._okSayacTimer = window.setInterval(function () {
      kalan--;
      if (kalan <= 0) {
        window.clearInterval(devamBtn._okSayacTimer);
        devamBtn._okSayacTimer = null;
        if (sayacEl) sayacEl.textContent = '';
        devamBtn.classList.remove('ok-kilitli');
        return;
      }
      if (sayacEl) sayacEl.textContent = kalan;
    }, 1000);
  }

  function oyunuBitir() {
    oyunAktif = false;
    sahne.classList.remove('oyun-aktif');
    window.clearTimeout(spawnTimer);
    if (sonRaf) window.cancelAnimationFrame(sonRaf);
    elIpucuGizle();
    aktifDusenler.forEach(function (d) { d.el.remove(); });
    aktifDusenler = [];

    // Oyun süre dolmadan da bitebilir (TOPLAM_DUSEN'in tamamı erkenden
    // spawn olup düşüp bittiyse) — bu durumda son karede sayaç hâlâ
    // "2sn" gibi bir değer gösteriyor olabilir, oyun bittiği hâlde
    // ekranda süre akıyormuş gibi durup kafa karıştırıyordu ("bug"
    // şikayeti buradan geliyor). Oyun bittiğinde sayaç her zaman 0'a
    // sabitlenir.
    if (sureEl) {
      sureEl.textContent = 0;
      sureEl.classList.remove('kritik');
    }

    // 5 kademeden hangisi kazanıldıysa CSS bunu data-sonuc-tier
    // özniteliğine göre gösterir (bkz. cerezshop-oyun.css).
    if (sonucKatman) sonucKatman.setAttribute('data-sonuc-tier', oyunSonucu);
    devamButonuKilitle(sonucKatman ? sonucKatman.querySelector('[data-tier="' + oyunSonucu + '"]') : null);

    var kazandi = oyunSonucu !== 'basarisiz';
    if (kazandi) {
      // Kutlama: kavanoz zıplar, konfeti patlar, sonuç kartı biraz
      // gecikmeyle (efektlerin oturması için) açılır. Herhangi bir
      // kazanma kademesinde (sadece en üst kademede değil) çalışır.
      window.setTimeout(function () {
        kavanoz.classList.add('dolu');
        if (!azaltilmisHareket) konfetiPatlat();
        window.setTimeout(function () {
          if (sonucKatman) sonucKatman.classList.add('acik');
        }, 420);
      }, 150);
    } else {
      // Başarısızlıkta kutlama efekti yok, kart hemen açılır.
      if (sonucKatman) sonucKatman.classList.add('acik');
    }
  }

  function konfetiPatlat() {
    if (!konfetiKatman) return;
    konfetiKatman.innerHTML = '';
    // Gerçek bir patlama hissi için iki aşamalı hareket: önce kavanozdan
    // yukarı/yanlara doğru fırlama (--ok-kx-mid/--ok-ky-mid), sonra
    // yerçekimiyle aşağı düşüş (--ok-kx/--ok-ky). Tek yönlü "yukarıdan
    // aşağı düşen 26 küçük çubuk" eskisinden çok daha cansız duruyordu.
    var renkler = ['#d93a2b', '#e0a41c', '#1f1f1e', '#ffffff', '#2f6f4e', '#3b5bdb'];
    var merkezX = kavanozX + kavanozGenislik / 2;
    var merkezY = kavanozTop();
    var SAYI = 60;
    for (var i = 0; i < SAYI; i++) {
      var p = document.createElement('span');
      p.className = 'ok-konfeti' + (Math.random() < 0.5 ? ' ok-konfeti-yuvarlak' : '');
      p.style.left = merkezX + 'px';
      p.style.top = merkezY + 'px';
      p.style.background = renkler[i % renkler.length];

      // Yukarı açılan yarım daire içinde rastgele bir açıyla fırlatılıyor.
      var aci = rastgele(-165, -15); // derece (-90 tam yukarı)
      var hiz = rastgele(70, 190);
      var rad = aci * Math.PI / 180;
      var ortaX = Math.cos(rad) * hiz;
      var ortaY = Math.sin(rad) * hiz; // negatif = yukarı

      p.style.setProperty('--ok-kx-mid', ortaX.toFixed(0) + 'px');
      p.style.setProperty('--ok-ky-mid', ortaY.toFixed(0) + 'px');
      p.style.setProperty('--ok-kx', (ortaX + rastgele(-50, 50)).toFixed(0) + 'px');
      p.style.setProperty('--ok-ky', (ortaY + rastgele(260, 430)).toFixed(0) + 'px');
      p.style.setProperty('--ok-kr-mid', rastgele(90, 360).toFixed(0) + 'deg');
      p.style.setProperty('--ok-kr', rastgele(420, 900).toFixed(0) + 'deg');
      p.style.animationDuration = rastgele(1.5, 2.3).toFixed(2) + 's';
      p.style.animationDelay = rastgele(0, 0.22).toFixed(2) + 's';
      konfetiKatman.appendChild(p);
      (function (el) {
        window.setTimeout(function () { el.remove(); }, 2800);
      })(p);
    }
  }

  function oyunuSifirla() {
    if (sonucKatman) {
      sonucKatman.classList.remove('acik');
      sonucKatman.removeAttribute('data-sonuc-tier');
    }
    if (baslatPerde) baslatPerde.style.display = 'flex';
    kavanoz.classList.remove('dolu');
    yigin.innerHTML = '';
    guncelleIlerlemeSifir();
  }

  function guncelleIlerlemeSifir() {
    if (ilerlemeBar) ilerlemeBar.style.width = '0%';
    if (ilerlemeMesajEl) ilerlemeMesajEl.textContent = ilerlemeMesajiHesapla(0);
  }

  // Mobilde oyun başlar başlamaz kısa süreliğine kavanozun üstünde bir
  // el/parmak ikonu sağa-sola kayarak "kavanozu sürükleyebilirsin"
  // ipucu veriyor (CSS'te @media (max-width:699px) ile sadece mobilde
  // görünür). İlk gerçek etkileşimde (sürükleme ya da ok butonu) hemen
  // kayboluyor, kullanıcının önüne geçmiyor.
  var elIpucuTimer = null;
  function elIpucuGoster() {
    if (!elIpucuEl) return;
    elIpucuEl.classList.add('gorunur');
    window.clearTimeout(elIpucuTimer);
    elIpucuTimer = window.setTimeout(elIpucuGizle, 3200);
  }
  function elIpucuGizle() {
    if (!elIpucuEl) return;
    elIpucuEl.classList.remove('gorunur');
    window.clearTimeout(elIpucuTimer);
  }

  /* --- Kontroller: sürükleme (pointer events, mouse+touch ortak) --- */
  sahne.addEventListener('pointerdown', function (e) {
    if (!oyunAktif) return;
    // Mouse ile basılı tutup sürüklerken tarayıcının varsayılan davranışı
    // (metin/görsel seçimi başlatma, resimleri "sürükle" olarak
    // algılama) sahnenin çirkin bir seçili-gibi görünmesine yol
    // açıyordu — preventDefault bunu engelliyor (dokunmatikte
    // touch-action zaten .oyun-aktif sınıfıyla ayrıca kontrol ediliyor).
    e.preventDefault();
    elIpucuGizle();
    suruklemeBaslangicX = e.clientX;
    suruklemeKavanozBaslangicX = kavanozX;
    sahne.setPointerCapture && sahne.setPointerCapture(e.pointerId);
  });

  sahne.addEventListener('pointermove', function (e) {
    if (!oyunAktif || suruklemeBaslangicX === null) return;
    var fark = e.clientX - suruklemeBaslangicX;
    kavanozXAyarla(suruklemeKavanozBaslangicX + fark);
  });

  function suruklemeBitir() { suruklemeBaslangicX = null; }
  sahne.addEventListener('pointerup', suruklemeBitir);
  sahne.addEventListener('pointercancel', suruklemeBitir);
  sahne.addEventListener('pointerleave', suruklemeBitir);

  /* --- Kontroller: sol/sağ butonlar (basılı tutma) --- */
  function butonBagla(btn, flagAyarla) {
    if (!btn) return;
    var basla = function (e) { e.preventDefault(); elIpucuGizle(); flagAyarla(true); };
    var bitir = function () { flagAyarla(false); };
    btn.addEventListener('pointerdown', basla);
    btn.addEventListener('pointerup', bitir);
    btn.addEventListener('pointerleave', bitir);
    btn.addEventListener('pointercancel', bitir);
  }
  butonBagla(solBtn, function (v) { solBasili = v; });
  butonBagla(sagBtn, function (v) { sagBasili = v; });

  /* --- Klavye erişimi (masaüstü) --- */
  window.addEventListener('keydown', function (e) {
    if (!oyunAktif) return;
    if (e.key === 'ArrowLeft') kavanozXAyarla(kavanozX - 24);
    if (e.key === 'ArrowRight') kavanozXAyarla(kavanozX + 24);
  });

  /* --- Başlat / tekrar oyna / kupon kopyala --- */
  // Kullanıcı başlangıç bilgilendirme metnini (hediyeler, süre vb.) hiç
  // okumadan hemen "Oyuna Başla"ya basmasın diye buton BASLAT_BEKLEME_SN
  // saniye pasif kalıyor; butonun sağındaki sayaç kaç saniye kaldığını
  // gösterip geri sayıyor, süre bitince gizlenip buton aktifleşiyor.
  // Sadece İLK giriş ekranında (data-ok-baslat-btn) — "Tekrar
  // Dene/Tekrar oyna" butonlarında yok, kullanıcı kuralları zaten
  // öğrenmiş oluyor.
  var BASLAT_BEKLEME_SN = 3;
  if (baslatBtn) {
    baslatBtn.disabled = true;
    var kalanSayac = BASLAT_BEKLEME_SN;
    if (baslatSayacEl) baslatSayacEl.textContent = kalanSayac;
    var sayacTimer = window.setInterval(function () {
      kalanSayac--;
      if (kalanSayac <= 0) {
        window.clearInterval(sayacTimer);
        if (baslatSayacEl) baslatSayacEl.textContent = '';
        baslatBtn.disabled = false;
        return;
      }
      if (baslatSayacEl) baslatSayacEl.textContent = kalanSayac;
    }, 1000);
    baslatBtn.addEventListener('click', oyunuBaslat);
  }
  tekrarBtnlar.forEach(function (btn) {
    btn.addEventListener('click', function () {
      oyunuSifirla();
      oyunuBaslat();
    });
  });

  kopyalaBtnlar.forEach(function (kopyalaBtn) {
    var kuponKodEl = kopyalaBtn.closest('.ok-kupon').querySelector('[data-ok-kupon-kod]');
    if (!kuponKodEl) return;
    kopyalaBtn.addEventListener('click', function () {
      var kod = kuponKodEl.textContent.trim();
      var tamamlandi = function () {
        kopyalaBtn.textContent = 'Kopyalandı ✓';
        kopyalaBtn.classList.add('kopyalandi');
        window.setTimeout(function () {
          kopyalaBtn.textContent = 'Kopyala';
          kopyalaBtn.classList.remove('kopyalandi');
        }, 1600);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(kod).then(tamamlandi).catch(function () {
          yedekKopyala(kod, tamamlandi);
        });
      } else {
        yedekKopyala(kod, tamamlandi);
      }
    });
  });

  // Hediye/Jumbo kademelerinde, admin panelden gerçek ürünün Variant
  // ID'si girilmişse "Hediyeni Sepete Ekle" butonu görünür (bkz. liquid).
  // Tıklanınca: ürünü Storefront Cart API ile sepete ekler, ardından
  // Shopify'ın kendi indirim uygulama linkiyle (/discount/KOD?redirect=..)
  // sepete yönlendirir — kupon checkout'a varmadan otomatik uygulanmış
  // olur, kullanıcı ne kodu elle girer ne de hangi ürünü ekleyeceğini
  // arar. Bilerek SADECE bu sayfada, kullanıcının GERÇEKTEN tıkladığı bir
  // butona bağlı çalışır — localStorage'a "kazandı" bayrağı YAZMIYORUZ
  // (sahte bayrakla sınırsız bedava ürün alınabilecek bir açık
  // oluşturmamak için); tek risk kupon kodunun sızması, ki bu normal bir
  // indirim kodu sızıntısından farksız ve admin panelden anında kapatılabilir.
  var hediyeSepeteEkleBtnlar = document.querySelectorAll('[data-ok-hediye-sepete-ekle]');
  hediyeSepeteEkleBtnlar.forEach(function (btn) {
    // Orijinal metin, tıklanmadan ÖNCEKİ hâliyle burada saklanıyor —
    // hem .catch() hem de bfcache düzeltmesi (aşağıda) bunu kullanıyor.
    btn.setAttribute('data-orijinal-metin', btn.textContent);
    btn.addEventListener('click', function () {
      var varyantId = btn.getAttribute('data-varyant-id');
      var kuponKodu = btn.getAttribute('data-kupon-kodu');
      if (!varyantId) return;

      btn.disabled = true;
      var eskiMetin = btn.getAttribute('data-orijinal-metin') || btn.textContent;
      btn.textContent = 'Ekleniyor…';

      // Önce sepete BAK: hediye ürünü zaten sepette varsa (ör. daha önce
      // eklenmiş, veya kullanıcı butona iki kez bastıysa/geri-ileri
      // gidip geldiyse) tekrar eklemiyoruz — çift adet sepete girmesin
      // diye. Yoksa normal şekilde ekleyip devam ediyoruz. İkisinde de
      // sonunda aynı yere (indirim linki üzerinden anasayfa) gidiliyor.
      fetch('/cart.js')
        .then(function (res) { return res.json(); })
        .then(function (sepet) {
          var zatenSepette = (sepet.items || []).some(function (item) {
            return String(item.variant_id) === String(varyantId);
          });
          if (zatenSepette) return;
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: varyantId, quantity: 1 }] })
          }).then(function (res) {
            if (!res.ok) throw new Error('cart/add başarısız');
          });
        })
        .then(function () {
          // "sepete ekle ve alışverişe devam et anasayfaya atmalı, ama
          // arkaplanda sepete eklenmiş olsun" isteğiyle: ürün sepette
          // (yeni eklendi ya da zaten oradaydı) ve kupon aşağıdaki
          // /discount/ isteğiyle oturuma uygulanıyor — kullanıcı sepete
          // değil, anasayfaya yönlendiriliyor (alışverişe oradan devam
          // eder, hediyesi sepetinde bekliyor olur).
          window.location.href = '/discount/' + encodeURIComponent(kuponKodu) + '?redirect=/';
        })
        .catch(function () {
          // Sepete bakma/ekleme başarısız olursa (ör. ürün kaldırılmış/
          // stok yok) kullanıcıyı hiç yönlendirmeden bırakmamak için en
          // azından anasayfaya gönderiyoruz; buton eski haline dönüyor ki
          // tekrar denenebilsin.
          btn.disabled = false;
          btn.textContent = eskiMetin;
          window.location.href = '/';
        });
    });
  });

  // BUG FİX: "Hediyeni Sepete Ekle"ye basılınca metin "Ekleniyor…" olup
  // buton disable edilir, sonra BAŞARILI olursa sayfadan ayrılırız
  // (metin hiç geri alınmaz — çünkü zaten yönlendiriyoruz). Kullanıcı
  // tarayıcının GERİ tuşuna basarsa sayfa çoğu zaman ağdan yeniden
  // yüklenmez, tarayıcının "bfcache"inden (o anki DOM hâliyle, yani
  // hâlâ "Ekleniyor…" yazan/disabled butonla) geri gelir — sayfa
  // gerçekte etkileşime hazır olduğu hâlde buton öyle kilitli görünür.
  // "pageshow" olayının persisted=true olması tam olarak bu durumu
  // (bfcache'den geri dönüş) ayırt eder; böyle bir dönüşte tüm
  // "Hediyeni Sepete Ekle" butonlarını orijinal metnine/aktif hâline
  // sıfırlıyoruz.
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    hediyeSepeteEkleBtnlar.forEach(function (btn) {
      btn.disabled = false;
      btn.textContent = btn.getAttribute('data-orijinal-metin') || btn.textContent;
    });
  });

  function yedekKopyala(metin, cb) {
    var ta = document.createElement('textarea');
    ta.value = metin;
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    try { document.execCommand('copy'); } catch (e) { /* sessiz geç */ }
    document.body.removeChild(ta);
    cb();
  }

  window.addEventListener('resize', function () {
    GENISLIK_PX = genislikPxHesapla();
    if (oyunAktif) olcek();
    ustBaslikYuksekligiOlc();
  });

  // Sitenin gerçek header'ı (bkz. sections/oyun-header-group.json) bu
  // sayfada da yükleniyor; yüksekliği tema ayarlarına göre değişebildiği
  // için sabit bir px değeri güvenilir değil. --ok-header-h değişkeni
  // ölçülüp yazılıyor ki .ok-sayfa mobilde ekranın TAM kalan yüksekliğini
  // kaplasın (header + oyun toplamı ekranı taşırıp gereksiz kaydırmaya
  // yol açmasın).
  function ustBaslikYuksekligiOlc() {
    var header = document.querySelector('header.header') || document.querySelector('[data-header]');
    var yukseklik = header ? header.getBoundingClientRect().height : 0;
    document.documentElement.style.setProperty('--ok-header-h', yukseklik + 'px');
  }
  ustBaslikYuksekligiOlc();
  // Fontlar/logo geç yüklenip header boyutunu son anda değiştirebiliyor;
  // sayfa tam yüklendikten kısa bir süre sonra bir kez daha ölç.
  window.addEventListener('load', ustBaslikYuksekligiOlc);
  window.setTimeout(ustBaslikYuksekligiOlc, 400);

  olcek();
  guncelleIlerlemeSifir(); // sayfa ilk açıldığında da "sıradaki ödül" mesajı görünsün
})();
